import { render, staticRenderFns } from "./AppointmentsPaymentDialogContent.vue?vue&type=template&id=1cb79785"
import script from "./AppointmentsPaymentDialogContent.vue?vue&type=script&lang=ts"
export * from "./AppointmentsPaymentDialogContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports